import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../useAuth';

interface PrivateRouteProps {
  element: JSX.Element;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ element }) => {
  const { isAuthenticated, initializing } = useAuth();

  if (initializing) {
    return null;
  }

  return isAuthenticated ? element : <Navigate to="/login" replace />;
};

export default PrivateRoute;